import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalSize, ModalSizeEnum } from '../../models/modal-sizes';

@Component({
    selector: 'app-shared-modal-content-projection',
    templateUrl: './shared-modal-content-projection.component.html',
    styleUrls: ['./shared-modal-content-projection.component.scss'],
    standalone: false
})
export class SharedModalContentProjectionComponent {

  @Input() isHeaderCloseIconVisible = true;
  @Input() modalTitle: string;
  @Input() backdropDismiss = true;
  @Input() modalSize: ModalSize = 'large';

  @Output() readonly closeModalEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  protected readonly modalSizeEnum = ModalSizeEnum;

  onBackdropClick(): void {
    if (this.backdropDismiss) {
      this.closeModalEvent.emit(true);
    }
  }

  onCloseModalClick(): void {
    this.closeModalEvent.emit(true);
  }

}
